import angular from 'angular';

require('./lbaPerDiemGrid.scss');
require('../lbaRouteRoot/lbaRouteRoot.scss');

const lbaPerDiemGrid = angular.module('app.lbaPerDiemGrid', []);

lbaPerDiemGrid.component('lbaPerDiemGrid', {
  bindings: {},
  controllerAs: 'vm',
  controller: ['perDiemService', '$rootScope', '$http', '$location', 'Upload', lbaPerDiemGridCtrl],
  template: require('./lbaPerDiemGrid.html')
});

function lbaPerDiemGridCtrl(perDiemService, $rootScope, $http, $location, Upload) {
  let vm = this;
  vm.getObjectPropertyValue = getObjectPropertyValue;
  vm.onClick = onClick;
  vm.addNew = addNew;

  vm.filters = '';
  vm.ready = false;

  var gridColumns = [
    { name: 'Source', key: 'Source' },
    { name: 'Destination Name', key: 'DestinationName' },
    { name: 'City', key: 'City' },
    { name: 'Country Code', key: 'CountryCode' },
    { name: 'Season Start', key: 'SeasonStart' },
    { name: 'Season End', key: 'SeasonEnd' },
    { name: 'Lodging Per Diem', key: 'LodgingPerDiem' },
    { name: 'Effective Date', key: 'EffectiveDate' },
    { name: 'Expiration Date', key: 'ExpirationDate' }
  ];

  vm.resource = {
    header: gridColumns,
    rows: []
  };

  vm.settings = {
    displayName: 'Per Diem',
    dataAt: 'PerDiemDefaultRates',
    canCopyItem: true,
    canAddNew: true,
    gridCols: gridColumns
  };

  perDiemService.getData(() => {
    vm.resource.rows = perDiemService.data;
    vm.ready = true;
  });

  function getObjectPropertyValue(obj, path, defaultValue = null) {
    return _.get(obj, path, defaultValue);
  }

  function onClick(row) {
    perDiemService.perDiemGridItem = row;
    window.localStorage['perDiemGridItem'] = JSON.stringify(row);
    perDiemService.perDiemGridStatus = vm.copyMode ? "copy" : "edit";
    window.localStorage['perDiemGridStatus'] = vm.copyMode ? "copy" : "edit";
    $location.path($location.$$path + '/data');
  }

  function addNew() {
    perDiemService.perDiemGridStatus = "add";
    window.localStorage['perDiemGridStatus'] = "add";
    window.localStorage.removeItem('perDiemGridItem');
    $location.path($location.$$path + '/data');
  }
}

export default lbaPerDiemGrid;


// WEBPACK FOOTER //
// ./src/components/lbaPerDiemGrid/lbaPerDiemGrid.js